import { render, staticRenderFns } from "./SectionWrappe.vue?vue&type=template&id=6798d312&scoped=true&"
import script from "./SectionWrappe.vue?vue&type=script&lang=ts&"
export * from "./SectionWrappe.vue?vue&type=script&lang=ts&"
import style0 from "./SectionWrappe.scss?vue&type=style&index=0&id=6798d312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798d312",
  null
  
)

export default component.exports